import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { FormControl, Validators, FormBuilder, FormGroup } from "@angular/forms"
import { KapraoService } from "src/services/kaprao.service"
import { MatSnackBar } from "@angular/material/snack-bar"
import { SnackBarComponent } from "../../shared/snack-bar/snack-bar.component"
import { TranslateService, LangChangeEvent } from "@ngx-translate/core"

@Component({
    selector: "app-info",
    templateUrl: "./info.component.html",
    styleUrls: ["./info.component.scss"],
})
export class InfoComponent implements OnInit {
    isLoading = true
    @ViewChild("changePassDialog") changePassDialog: TemplateRef<any>
    oldPass
    errorCode
    errorMsg
    passForm: FormGroup
    showPassC1 = false
    showPassC2 = false
    showPassC3 = false
    userProfile
    selectedLang
    constructor(
        private formBuilder: FormBuilder,
        private dialog: MatDialog,
        private service: KapraoService,
        private _snackBar: MatSnackBar,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.selectedLang = this.translate.currentLang
        this.translate.onLangChange.subscribe(
            (langChangeEvent: LangChangeEvent) => {
                this.selectedLang = langChangeEvent.lang
            }
        )
        this.getProfile()
        this.passForm = this.formBuilder.group({
            oldPassword: new FormControl("", {
                validators: [Validators.required],
            }),
            newPassword: new FormControl("", {
                validators: [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.maxLength(16),
                ],
            }),
            confirmNewPwd: new FormControl("", {
                validators: [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.maxLength(16),
                ],
            }),
            validators: this.password.bind(this),
        })
    }

    getProfile() {
        this.service.getProfile().then((res: any) => {
            console.log(res)
            if (res.code == "0000") {
                this.userProfile = res.data
                this.isLoading = false
            }
        })
    }
    openChangePass() {
        this.errorCode = null
        this.passForm = this.formBuilder.group({
            oldPassword: new FormControl("", {
                validators: [Validators.required],
            }),
            newPassword: new FormControl("", {
                validators: [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.maxLength(16),
                ],
            }),
            confirmNewPwd: new FormControl("", {
                validators: [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.maxLength(16),
                ],
            }),
            validators: this.password.bind(this),
        })
        this.dialog.open(this.changePassDialog, {
            panelClass: "changePassp-dialog",
        })
    }
    onChangePassword() {
        if (this.passForm.value.oldPassword == "") {
            return
        }
        if (this.passForm.value.newPassword == "") {
            return
        }
        if (this.passForm.value.confirmNewPwd == "") {
            return
        }
        if (
            this.passForm.value.newPassword != this.passForm.value.confirmNewPwd
        ) {
            return
        }
        if (!this.passForm.valid) {
            return
        }
        let dataForSend = this.passForm.value
        dataForSend._id = this.userProfile.id
        console.log(dataForSend)
        this.service.changePassword(dataForSend).then((res: any) => {
            console.log(res)
            if (res.code == 0) {
                this.dialog.closeAll()
                let sn = this._snackBar.openFromComponent(SnackBarComponent, {
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    panelClass: ["success"],
                    data: {
                        type: "success",
                        message: "Password changed",
                    },
                })
                this.isLoading = false
                sn.afterOpened().subscribe((_) => {
                    setTimeout(() => {
                        sn.dismiss()
                    }, 3300)
                })
            }
            // else if (res.code == 109) {
            //   this.errorCode = res.code;
            //   this.passForm.controls.oldPassword.setValue('');
            // }
            else {
                this.errorMsg = res.message
                this.errorCode = res.code
            }
        })
    }
    closeDialog() {
        this.dialog.closeAll()
    }
    password(formGroup: FormGroup) {
        console.log(formGroup)
        const { value: newPassword } = formGroup.get("newPassword")
        const { value: confirmNewPwd } = formGroup.get("confirmNewPwd")
        console.log(newPassword, confirmNewPwd)
        return newPassword === confirmNewPwd ? null : { passwordNotMatch: true }
    }
}
